import {Component, Injector} from '@angular/core';
import {AbstractListOrmComponent} from "../../AbstractListOrmComponent";
import {FaunaDataSource} from "../../../../services/persist/FaunaDataSource";
import {Monitoramento} from "../../../../domain/Monitoramento";
import {Especime} from "../../../../domain/Especime";
import {toKML} from '@placemarkio/tokml'
import {Feature, FeatureCollection} from "geojson";
import {ShareService} from "../../../../services/ShareService";
import {ModalController} from "@ionic/angular";
import {TrackingComponent} from "../../../tracking/tracking.component";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import {environment} from "../../../../../environments/environment";
@Component({
  selector: 'app-list-pessoa',
  templateUrl: './list-monitoramento.component.html',
  styleUrls: ['./list-monitoramento.component.scss'],
})
export class ListMonitoramentoComponent extends AbstractListOrmComponent<Monitoramento>{

  agenciavel = true
  override relations = ["projeto","campanha","local","jornada"]
  select = ['id','inicio','fim','projeto.nome','campanha.nome','local.nome']

  constructor(injector: Injector, ds: FaunaDataSource, private share: ShareService, private modalCtrl: ModalController) {
    super(injector, ds.getRepository(Monitoramento))
  }

  getExibirMapa(item: Monitoramento): boolean {
    const coordenadas = item.jornada?.pontos != undefined
    const especimes = item.especimes?.length || 0
    return coordenadas  || especimes > 0
  }

  async kml(item: Monitoramento) {
    const mon =await  this.repo.findOne({
      where : { id: item.id},
      relations: ['especimes','jornada','especimes.taxon']
    })
    const geojson = this.toGeojson(mon)
    const kmlNameDescription = toKML(geojson);
    await this.share.share(kmlNameDescription, "tracking.kml")
  }

  toGeojson(item: Monitoramento): FeatureCollection{
    const jornada = item.jornada
    const especimes: Feature[]  = item.especimes?.map((e: Especime) => {
      return {
        type: "Feature",
        geometry: e.ponto,
        properties: {
          id: e.id,
          name: e.taxon?.name,
          dataHora: e.dataHora
        }
      }
    })||[]

    const tracking : Feature = {
      type: "Feature",
      properties: {
        id: jornada?.id,
        dataHora: jornada?.inicio,
        name: "jornada",
        projeto: item.projeto?.nome,
        camapanha: item.campanha?.nome
      },
      geometry: jornada.pontos
    }

    return {
      "type": "FeatureCollection",
      "features": [tracking, ...especimes]
    }
  }

  async showMap(monitoramento: Monitoramento){
    const mon =await  this.repo.findOne({
      where : { id: monitoramento.id},
      relations: ['especimes','jornada','especimes.taxon']
    })
    const modal = await this.modalCtrl.create({
      showBackdrop: true,
      component: TrackingComponent,
      componentProps: {
        showHeader: true,
        monitoramento: mon,
      }
    })
    console.log('vai apresentar')
    await modal.present()
  }
  async geojson(item: Monitoramento) {
    const mon =await  this.repo.findOne({
      where : { id: item.id},
      relations: ['especimes','jornada','especimes.taxon']
    })
     const geojson = this.toGeojson(mon)
     await this.share.share(JSON.stringify(geojson), "tracking.geojson")
  } catch (error) {
    console.error('Error downloading file:', error);
  }

  async exportarExcel(item: Monitoramento) {
    const mon =await  this.repo.findOne({
      where : { id: item.id},
      relations: ['especimes','jornada','especimes.taxon','especimes.arquivos']
    })
    const nomeArquivo = 'relatorio.xlsx';
    // 1. Converte JSON para uma planilha (worksheet)
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.toJSON(mon));

    // 2. Cria um novo livro (workbook) e adiciona a planilha
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

    // 3. Escreve o arquivo e inicia o download
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.salvarComoArquivoExcel(excelBuffer, nomeArquivo);
  }

  private salvarComoArquivoExcel(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName);
  }

  toJSON(monitoramento: Monitoramento): any[]{
    const dadosParaExcel = monitoramento.especimes?.map(especime => {
      const obj =  {
        // --- Dados do Monitoramento ---
        'Monitoramento ID': monitoramento.id,
        'Projeto': monitoramento.projeto?.nome,
        'Distância Percorrida': monitoramento.distanciaPercorrida,
        'Campanha': monitoramento.campanha?.nome,
        'Local': monitoramento.local?.nome,
        'Início': monitoramento.jornada.inicio,
        'Fim': monitoramento.jornada.fim,
        "Duração": monitoramento.jornada.duracao,
        'Fase Lunar': monitoramento.faseLunar,
        'Estação': monitoramento.estacao,

        // --- Dados do Espécime ---
        'Espécime ID': especime.id,
        'Data/Hora': especime.dataHora,
        'Táxon': especime.taxon?.name || especime.taxon?.commonNames,
        'Bioma': especime.bioma?.nome,
        'Município': especime.municipio?.nome,
        'Sexo': especime.sexo,
        'Classe Etária': especime.classeEtaria,
        'Indivíduos': especime.individuos,
        'Observações': especime.observacoes,

        // --- Coordenadas (Ponto) ---
        'Latitude': especime.ponto?.coordinates?.[1],
        'Longitude': especime.ponto?.coordinates?.[0],

        // --- Métricas Físicas ---
        'Peso Corporal': especime.pesoCorporal,
        'Comprimento Total': especime.comprimentoTotal,

        // 'Arquivos': especime.arquivos.map( a=>  environment.url + "/api/storage/" + a.caminho).join("\n")
      };
      especime.arquivos.forEach((arquivo, index) => {
        obj[`Arq${index +1}` ] = environment.url + "/api/storage/" + arquivo.caminho
      })
      return obj
    })
    return dadosParaExcel;

    // Se não houver espécimes, exportamos apenas os dados do monitoramento
    // if (dadosParaExcel.length === 0) {
    //   dadosParaExcel.push({
    //     'Monitoramento ID': monitoramento.id,
    //     'Projeto': monitoramento.projeto?.nome,
    //     'Aviso': 'Nenhum espécime registrado'
    //   });
    // }

  }

}
